/**
 * useValuationAuth Hook
 * Handles authentication for valuation APIs
 */
import { supabase } from '../lib/supabase';
import logger from '../utils/logger';

export const useValuationAuth = () => {
  // Get user ID for localStorage keys
  const getUserId = () => {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        return user.id || 'anonymous';
      }
    } catch (e) {
      logger.error('Error getting user ID', { error: e });
    }
    return 'anonymous';
  };

  // Get authentication token - supports both Supabase and Flask auth
  const getAuthToken = async () => {

    // Check for Flask token first
    const flaskToken = localStorage.getItem('token');
    if (flaskToken) {
      return flaskToken;
    }

    // Check for Supabase session
    try {
      const { data: { session }, error } = await supabase.auth.getSession();

      if (session?.access_token) {
        return session.access_token;
      }
    } catch (err) {
      console.error('[AUTH DEBUG] Error getting Supabase session:', err);
      logger.error('Error getting Supabase session', { error: err });
    }

    return null;
  };

  // Check if token is valid - supports both Supabase and Flask auth
  const checkToken = async (setError) => {
    const token = await getAuthToken();
    if (token) {
      return true;
    }

    // No valid authentication found
    setError('Session expired. Please log in again.');
    setTimeout(() => {
      window.location.href = '/login';
    }, 2000);
    return false;
  };

  return {
    getUserId,
    getAuthToken,
    checkToken
  };
};
